export class Document {
    DocumentID: number;
    CaseID: any;
    FileID?: any;
    CreationDate: Date;
    FromEIS: string;
    DocumentPostalItemCodeTC: string;
    QuestionerPersonTypeTC: string;
    FileName: string;
    Title: string;
    CEDID: number;
    CreatedDate: Date;
    CreatedByUserId?: any;
    IsNew: boolean;
    DmsReference?: any;
    EisReference: string;

    public constructor(init?: Partial<Document>) {
        Object.assign(this, init);
    }
}
